import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { CAMPOS_SEDE, ordenarSedes, muestraSelectorSede, type FilaSede } from './sedes';

// F1a: sedes de la empresa para los selectores y filtros (Trabajadores, Bodegas, Plan, Perfil SSO). Si no se pueden
// leer (por ejemplo, sin M40 en la base), la lista queda vacía y las pantallas se ven como con una sola sede.
export async function cargarSedes(companyId: string): Promise<FilaSede[]> {
  try {
    const { data, error } = await supabase.from('company_sites').select(CAMPOS_SEDE).eq('company_id', companyId);
    if (error) throw error;
    return ordenarSedes((data ?? []) as unknown as FilaSede[]);
  } catch (e) {
    console.error('cargarSedes', e);
    return [];
  }
}

export function useSedes(companyId: string | null | undefined) {
  const [sedes, setSedes] = useState<FilaSede[]>([]);
  const recargar = useCallback(async () => {
    setSedes(companyId ? await cargarSedes(companyId) : []);
  }, [companyId]);
  useEffect(() => {
    let vivo = true;
    (companyId ? cargarSedes(companyId) : Promise.resolve([])).then(s => { if (vivo) setSedes(s); });
    return () => { vivo = false; };
  }, [companyId]);
  return { sedes, varias: muestraSelectorSede(sedes), recargar };
}
